import allcourses from "../../../assets/images/allcourses.jpg";
import contactInstitute from "../../../assets/images/contactInstitute.jpg";
import collab from "../../../assets/images/collab.jpg";

export const FaqData = [
  {
    id: 12,
    que: ` How many courses are you offering?`,
    answer: `Currently, LKCE is offering 4+ UG Courses which includes:\n • B.Tech Computer Science & Engineering 
                • B.Tech Civil Engineering
                • B.Tech Electronics & Communication Engineering 
                • B.Tech Mechanical Engineering
                `,
  },
  {
    id: 13,
    que: ` Are admissions open at Lyallpur Khalsa College Technical Campus for 2022-23?`,
    answer: `Admissions are open at Lyallpur Khalsa College Technical Campus for 2022-23 till 28/09/2022 as per notice received from IKG-PTU for AICTE and UGC approved Courses. Extended dates will be notified on the Website.`,
  },
  {
    id: 14,
    que: ` What steps Lyallpur Khalsa College Technical Campus has taken to support new students in taking admission?`,
    answer: `The admission to B.Tech.(CE, CSE, Data Sc., ECE and ME), B.Tech-LE
              (Lateral Entry), MBA, MCA, BHMCT, BBA, BCA, BCA (Lateral Entry),
              B.Voc.(Software Development), B.Voc.(Automobile Servicing),
              B.Voc.( Hospitality and Catering Management), B. Voc. (Tourism &
              Hospitality Management) & B.Com. (H) courses will be done strictly
              on the basis of guidelines issued by IK Gujral Punjab Technical
              University, Jalandhar. The admission form for taking admission in
              the above-mentioned courses are available at the registration
              counter of the Institute. The Counselling & Admission (CAD) Cell
              provides assistance in the following matters:\n • Provisional admission/Registration 
                • Admission form filling and procurement of supporting documents
                • Regular communication of important dates
                • Information about campus facilities and career opportunities
                Note: The admission in all the courses will be done on the basis of the merit of marks secured in the qualifying examination or otherwise as specified by the University.
                Start of Session: Even Semester- 1st January-30th June Odd Semester- 1st July- 31st December
                `,
  },
  {
    id: 15,
    que: ` How can I complete the admission process?`,
    answer: `Student can fill the Registration form by paying Rs. 5,000/- to book his/her seat in the desired course. Post the passing result of previous examination, student is required to fill in the admission form and submit the balance fees along with required documents.`,
  },
  {
    id: 16,
    que: ` What are the important dates regarding the admissions?`,
    answer: `The important dates for the start and end of admission process will be as notified by the University and AICTE.`,
  },
  {
    id: 17,
    que: ` What are the documents required for taking admission?`,
    answer: `The following documents are required while taking admission in every course at LKCTC:\n • Original certificates and mark sheets of previous examination
                passed i.e. 10th, 10+2 and Graduation (for PG Students).
                • Attested Xerox copies of these documents along with the completed admission form.
                • Migration Certificate in original from the previous University other than IKG PTU.
                • 4 Passport Size Photographs for the admission form and ID Card.
                • No Ragging Affidavit attested by Notary.
                • Gap Certificate, If Any.
                `,
  },
  {
    id: 18,
    que: ` What are the documents required for availing PMS concession while taking admission under Reserved Category?`,
    answer: `The following documents are required for availing PMS concession:\n • Original certificates and mark sheets of previous examination
                passed i.e. 10th, 10+2 and Graduation (for PG Students).
                • Attested Xerox copies of these documents along with the
                completed admission form.
                • Migration Certificate in original from the previous University
                other than IKG PTU.
                • 4 Passport Size Photographs for the admission form and ID Card.
                • No Ragging Affidavit attested by Notary.
                • Schedule Cast Certificate
                • Residence Certificate
                • Income Certificate And Affidavit
                • Copy of Adhaar Card (Self, Mother, Father)
                • Bank Account Copy
                • Gap Certificate, If Any.
                `,
  },
  {
    id: 19,
    que: ` Can a student apply for UG/PG program in absence of 10+2/Graduation final year result?`,
    answer: `Yes, Student can provisionally apply the seat, but seat will be confirmed after producing the pass result of 10+2/Graduation.`,
  },
  {
    id: 20,
    que: ` What if I decide to withdraw admission later? What are the refund rules?`,
    answer: `As per IK Gujral Punjab Technical University Guidelines/Notifications.`,
  },
  {
    id: 21,
    que: ` How can I get regular updates about the activities in the Department/Campus?`,
    answer: `Institute is having a mechanism for disseminating the updates about the activities in the Department/Campus through Class Whatsapp Group, Social Media Platforms like Facebook Page and Instagram Handle, and Students E-mail Id.`,
  },
  {
    id: 22,
    que: ` What is the minimum attendance requirement?`,
    answer: `As per IK Gujral Punjab Technical University Norms, 75% attendance is compulsory to appear in the final University examinations.`,
  },
  {
    id: 23,
    que: ` How to contact the Institute’s representative(s) for any required information?`,
    answer: ``,
    image: contactInstitute,
  },
  {
    id: 24,
    que: ` What are the various courses/programmes offered at LKCTC?`,
    answer: ``,
    image: allcourses,
  },
  {
    id: 25,
    que: ` Where can I get detailed information about the course curriculum?`,
    answer: `The detailed information about the curriculum for various courses is available at: https://ptu.ac.in/syllabus/`,
  },
  {
    id: 26,
    que: `What is the minimum fee payment for provisional registration?`,
    answer: `The minimum fee payment for provisional registration is Rs. 5000/- For UG courses and Rs.10000/- For PG Courses.`,
  },
  {
    id: 27,
    que: ` What are the fee payment options? `,
    answer: `The students can make the payment of fees either at the college fee counter or through online banking channels.`,
  },
  {
    id: 28,
    que: ` What are the fee payment options? `,
    answer: `The students can make the payment of fees either at the college fee counter or through online banking channels.`,
  },
  {
    id: 29,
    que: ` What are the highest placement package(s) offered to the students of LKCTC?  `,
    answer: `The Highest Package in School of Management has been Rs 20 Lakhs PerAnnum, followed by Rs 8.46 LPA. The highest package in School of IT has been Rs. 8 LPA, followed by Rs. 3 LPA.`,
  },
  {
    id: 30,
    que: ` What are the national/international collaborations, linkages or MoUs with the Industry or Academia? `,
    answer: `LKCTC has collaborated with various prominent organizations from Industry and Academics for internships, field trips, industrial visits, training & placement, research and other academic activities. Memorandum of Understanding(MoUs) have been established with following organizations: \n`,
    image: collab,
  },
  {
    id: 31,
    que: ` How does LKCTC helps in nurturing the interview and soft skills among the students?`,
    answer: `LKCTC provides a bunch of activities aligned towards developing the InterviewSkills of the students in particular and overall Skill Development and employability ingeneral. These include in campus Mock Interviews, Group Discussions, Resume Building Sessions, Industrial Visits to give them practical exposure, Case Studies, Role Plays, Guest Lectures, Seminars, Workshops, Alumni interaction with current students, Skill Development classes, Competitive Exam preparation, etc. that help the students indeveloping and grooming their overall personality.`,
  },
  {
    id: 32,
    que: ` What co-curricular activities are organized in the Institute for holistic development of the students?`,
    answer: `Co-curricular activities are an expansion of the formal learning practices that supplement the academic curriculum. In LKCTC we also organize various co-curricular activities likeworkshops, guest lecture, seminars, club activities, entrepreneurial activities, culturalactivities, sports activities and NSS activities. This year RI&E Committee organized 360 Degree Analysis of union budget 2022 with an aim to make students aware about budget highlights.We also have various student driven clubs like Finance, HR, marketing, literary, Digitalmarketing and social sensitization. under these clubs’ various events are being organized likecase study analysis, Logo making, Psychometric analysis test, finance and business quiz,entrepreneurship activities, donation drive etc. The objective of these activities is to help students to develop creative thinking, critical thinking, communication, social skills,intellectual skills, moral values, and collaborative abilities.
`,
  },
  {
    id: 1,
    que: `In what cases will I be given Provisional Admission?`,
    answer: `You will be considered for Provisional Admission in following cases:\n • Non submission of Certificate of qualifying examination Result 
                • Awaited in qualifying examination Backlog in qualifying examination
                • Non submission of attested copy of Matriculation Certificate/qualifying certificate/ residence proof/ any other document required for admission. 
                • Non payment of full Course Fee or any other fee as prescribed. 
                •  Pending verification of attested documents with their corresponding Original documents.
                `,
  },
  {
    id: 2,
    que: `Do you offer lateral entry? If yes, in which courses?`,
    answer: `Yes, we provide lateral entry in B.Tech i.e., Computer Science & Engineering, Mechanical Engineering, Civil Engineering and Electronics Communication Engineering.`,
  },
  {
    id: 3,
    que: `What is the last date of applying?`,
    answer: `The dates for counseling are released by PTU which are published in all of the leading newspapers at national Level. However, we suggest you to register well in advance and not wait for the last moment. For registration, please contact any of our admission offices and our team will be happy to guide you.`,
  },
  {
    id: 4,
    que: `What is Lateral Entry?`,
    answer: `If a student has done a Diploma in a particular field, he can take admission in the 2nd year of the corresponding course. This is applicable for Graduate as well as Post Graduate courses, but the lateral entry is subject to the fulfillment of the eligibility criteria prescribed by the University.`,
  },
  {
    id: 5,
    que: `What are the Co-Curricular activities goes on in your college?`,
    answer: `Our Institute has a complete pre-planned package of the co-curricular activities for each and every semester of an academic session. Inter College and Intra College Competitions are offered to the students to participate. Cultural Fests and Technical Fests are essential part of such events. Moreover, events are planned to give students a change and exposure to sharp their minds and bright their future as well.`,
  },
  {
    id: 6,
    que: `Does the college provide hostel facility within the campus?`,
    answer: `Separate Hostel facility is available for Boys and Girls. Aesthetically designed, the hostel blocks are spread around the campus. The hostels are interconnected, mostly in blocks of three. Each of the blocks has a square in the center where badminton courts with good turf are maintained, with some blocks also having lawns in the square. Each hostel block has a common room where facilities such as wall-mounted televisions, table-tennis tables, carom and chess games are available. It is the common room that provides the scene of action for get-togethers, parties and informal discussions. Each block is also equipped with fully automatic washing machines and each floor is further equipped with landline phones, water coolers and water purifiers. The individual rooms are well having full time wireless internet connectivity with direct lines to the main LAN. The housekeeping staff is available through the week and takes care of cleaning the rooms, corridors and rest rooms on a daily basis. Dedicated mess facilities and round the clock canteen facilities are available in the hostels. Apart from this, the hostels also connected with excellent gymnasium.`,
  },
  {
    id: 7,
    que: `Does your college provide help to the students for interview preparation and soft skills development?`,
    answer: `At LKCE, we have a separate Department for Communication Skills and Personality Development with highly qualified and skillful faculty who provides Career Guidance and help students to enhance their skills required for the jobs. Our institute organizes such events that successfully brought both technical and presentation skills in the students to confidently speak their minds. Special workshops, seminars, presentations, guest lectures, mock interviews and many other such activities are being organized for the students to develop their soft skills and prepare them for interviews.`,
  },
  {
    id: 8,
    que: `Does the college guarantee Job Placements?`,
    answer: `Our Institute has a dedicated Training & Placement cell which provides training to the candidates and remains in touch with the top companies. LKCE pins its faith on its Training & Placements for acting an interface between the industry and the academia. A competent and vibrant team collectively works for industrial exposure and placements of the students. T&P liaisons with the industry for the industrial visits for a clear practical perspective of the theoretical concepts and experiential learning on latest trends by students apart from the major aspect of providing placements. Inviting eminent personalities from Government, Business and Academia for addressing students as to enrich their knowledge and establish a shared learning experience is another facet of T&P tasks. We value our industrial relations and wish to uphold the same.`,
  },
  {
    id: 9,
    que: `What about the faculty of your college?`,
    answer: `This is one of our strength that all of our faculty members are well qualified, synergized, result oriented and possessing the industrial experience as well. Moreover, most of the faculty members are PhDs, M.Techs, and other postgraduate qualifications.`,
  },
  {
    id: 10,
    que: ` When should hostlers report?`,
    answer: `The Hostel Students should report at least on 14th August. However, for admissions happening after the beginning of session, can report later.`,
  },
  {
    id: 11,
    que: ` When do the classes begin for first year?`,
    answer: `Normally the classes for the first Semester students begin in the month of August. The Tentative Date for this session is 16th August. If the date changes as per PTU Calendar, it shall be notified on the college website. Every Year, the admissions continue till September because of delayed counseling in other states. There is provision of late classes as well.`,
  },
];
